module.exports = __webpack_public_path__ + "static/media/baug_2.a89aa877.png";